import Axios from 'axios';
import { StatusDto } from '../types';

export const addNewsletterSubscription = async (email: string): Promise<StatusDto> => {
  return (
    await Axios.post(`${process.env.REACT_APP_API_URL}/notifications/newsletter/subscriptions`, {
      email,
      product: 'HOSTCAP',
    })
  ).data;
};
